import { render, staticRenderFns } from "./IMain.vue?vue&type=template&id=68faad74&scoped=true&"
import script from "./IMain.vue?vue&type=script&lang=js&"
export * from "./IMain.vue?vue&type=script&lang=js&"
import style0 from "./IMain.vue?vue&type=style&index=0&id=68faad74&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"
import style1 from "./IMain.vue?vue&type=style&index=1&id=68faad74&prod&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68faad74",
  null
  
)

export default component.exports